<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-04-30 20:59:55
 * @LastEditors: ???
 * @LastEditTime: 2022-05-14 14:18:05
-->
<template>
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <el-form-item label="用户名">
          <el-input @keyup.enter.native="searchQuery" v-model="queryParam.name" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <el-button size="mini" type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #sex="slotData">
        <p v-if="slotData.data.row.sex == 1">男</p>
        <p v-if="slotData.data.row.sex == 0">女</p>
        <p v-if="slotData.data.row.sex == 2">保密</p>
      </template>
      <template #handlerSlot="slotData">
        <el-button size="mini" @click="handleEdit(slotData.data.row)">修改</el-button>
        <el-button size="mini" @click="resetPassWordRow(slotData.data.row)">重置密码</el-button>
        <el-button type="danger" size="mini" @click="handleDelete(slotData.data.row.id)">删除</el-button>
      </template>
    </e-table>
    <editPwd ref="editPwd"></editPwd>
    <modal-form ref="modalForm" @ok="modalFormOk"></modal-form>
  </div>
</template>

<script>
import modalForm from './component/userModal'
import editPwd from './component/editPwdModal'

import eTable from '@/components/table'
import { listMixin } from '@/mixins/listMixin'
export default {
  components: { eTable, modalForm, editPwd },
  mixins: [listMixin],
  props: {},
  data () {
    return {
      deleteKey: 'userId',
      url: {
        list: 'user/getUserList',
        delete: 'user/deleteUser',
      },

      //字段权限
      columns: [
        // { field: 'code', label: '角色编码' },
        {
          field: 'userName',
          label: '用户名',
        },
        {
          field: 'realName',
          label: '姓名',
        },
        {
          field: 'sex',
          label: '性别',
          slotName: 'sex',
          columnType: 'slot',
        },

        { field: 'mobile', label: '手机号' },
        { field: 'email', label: '邮箱' },
        { field: 'roleName', label: '所属角色' },

        // { field: 'createDate', label: '创建时间' },

        // { field: 'createName', label: '创建人' },

        {
          width: 260,
          label: '编辑',
          slotName: 'handlerSlot',
          columnType: 'slot',
        },
      ],
    }
  },
  watch: {},
  computed: {},
  methods: {
    resetPassWordRow (row) {
      console.log(this.$refs)
      this.$refs.editPwd.edit(row)
    },
    fetchData () {
      console.log(this.ipagination.page)
    },
    add (val) {
      console.log(val)
    },
    edit (val) { },
    del (val) { },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
}
</style>
